import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import cn from 'classnames';
import { CASHBOX_TYPES } from 'constants/cashboxTypes';
import { Button } from 'components/Button';
import styles from './AddCashboxCard.scss';

export const AddCashboxCard = ({ onClick, type = CASHBOX_TYPES.ACCOUNT }) => {
  const isLocationType = type === CASHBOX_TYPES.SAFE || type === CASHBOX_TYPES.REGISTER;

  return (
    <Button
      className={cn(styles.addCard, { [styles.locationCard]: isLocationType, [styles.accountCard]: !isLocationType })}
      onClick={onClick}
      noStyle
    >
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <FontAwesomeIcon icon={faPlus} className={styles.plusIcon} />
        </div>
        <p className={styles.text}>{isLocationType ? 'Додати локацію' : 'Додати рахунок'}</p>
      </div>
    </Button>
  );
};
